<template>
	<section class="row margin-tb-150" dusk="failure">

		<article class="wrap--sm">

			<section class="row">

				<header class="confirm margin-b-50 center">

					<h3>Problemer med betalingskort</h3>

					<p>Stripe kan desværre ikke tage imod dit kort, forsøg venligst med et andet betalingskort</p>
					<p><strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong></p>

				</header>

				<section class="row margin-b-50 center">

					<router-link class="btn--primary" :to="{name:'make-order.order.approve'}">Gå til betaling</router-link>

				</section>

			</section>

		</article>

	</section>
</template>

<script>
    export default {
        name: "failedOrder",
    }
</script>

<style scoped>

</style>
